<template>
    <div class="tsa-verifyCode" :class="[{'is-border': border=== true, 'disabled': disabled===true}]" @click="countStart">
        <p>{{ codeMsg }}</p>
    </div>
</template>
<script>
import { mobilePhoneReg, emailReg } from '@/config/regular.js'
export default {
    name: 'tsa-verifyCode',
    props: {
        type:{
            type: String,
            default: ''
        },
        phone: {
            type: String,
            default: ''
        },
        border:{
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            codeMsg: '获取验证码',
            code: 60,
            time: null,
            disabled: false,
        }
    },
    watch:{
        
    },
    methods: {
        countStart () {
            if (this.disabled) return
            let phone = this.phone.trim()
            if (!phone) {
                this.$TsaToastV2.show({
                    type: 'warn',
                    message: this.type=='phone'?'请输入正确的手机号':'请输入正确的手机号或者邮箱'
                })
                return
            }
            if(this.type=='phone'){
                if (mobilePhoneReg.test(phone)) {
                    this.$emit('on-start', {
                        signupType: 'PHONE'
                    })
                }else{
                    this.$TsaToastV2.show({
                        type: 'warn',
                        message: '请输入正确的手机号'
                    })
                } 
            }else{
                if (mobilePhoneReg.test(phone)) {
                    this.$emit('on-start', {
                        signupType: 'PHONE'
                    })
                }else if (emailReg.test(phone)) {
                    this.$emit('on-start', {
                        signupType: 'EMAIL'
                    })
                } else {
                    this.$TsaToastV2.show({
                        type: 'warn',
                        message: '请输入正确的手机号或者邮箱'
                    })
                }
            }
        },
        getCode () {
            if (this.disabled) return
            this.disabled = true
            this.time = setInterval(() => {
                this.code--
                this.codeMsg = `(${this.code}s)重新获取`
                if (this.code === 0) {
                    this.disabled = false
                    this.codeMsg = `重新获取`
                    this.code = 60
                    clearInterval(this.time)
                }
            }, 1000)
        },
        reset(){
            clearInterval(this.time)
            this.codeMsg= '获取验证码';
            this.code=60;
            this.time=null;
            this.disabled=false;
        }
    },
    beforeDestroy () {
        clearInterval(this.time)
    }
}
</script>
<style lang="scss" scoped>
    @media screen and (min-width:1101px) {
        @import './css/pc.scss';
    }
    @media screen and (max-width:1100px) {
        @import './css/mobile.scss';
    }
</style>